import { render, staticRenderFns } from "./MovieCard.vue?vue&type=template&id=2d063889&scoped=true"
import script from "./MovieCard.vue?vue&type=script&lang=js"
export * from "./MovieCard.vue?vue&type=script&lang=js"
import style0 from "./MovieCard.vue?vue&type=style&index=0&id=2d063889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d063889",
  null
  
)

export default component.exports